<template>
    <!-- Sidebar -->
    <div class="sidebar" id="sidebar">
        <!-- Logo -->
        <div class="sidebar-logo">
            <router-link to="/admin-template/index" class="logo logo-normal">
                <img src="@/assets/admin/img/logo.svg" alt="Logo">
            </router-link>
            <router-link to="/admin-template/index" class="logo-small">
                <img src="@/assets/admin/img/logo-small.svg" alt="Logo">
            </router-link>
            <router-link to="/admin-template/index" class="dark-logo">
                <img src="@/assets/admin/img/logo-white.svg" alt="Logo">
            </router-link>
        </div>
        <!-- /Logo -->
        <div class="sidebar-inner slimscroll">
            <perfect-scrollbar class="scroll-area" :settings="settings" @ps-scroll-y="scrollHanle">
                <div id="sidebar-menu" class="sidebar-menu">
                    
                    <div class="form-group">
                        <!-- Search -->
                        <div class="input-group input-group-flat d-inline-flex">
                            <span class="input-icon-addon">
                                <i class="ti ti-search"></i>
                                </span>
                            <input type="text" class="form-control" placeholder="Search">
                            <span class="group-text">
                                <i class="ti ti-command"></i>
                            </span>
                        </div>
                        <!-- /Search -->
                    </div>
                    <sidebar-menu></sidebar-menu>
                </div>
            </perfect-scrollbar>
        </div>
    </div>
    <!-- /Sidebar -->
</template>


<script>
import { PerfectScrollbar } from "vue3-perfect-scrollbar";
import "vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css";

export default {
  components: {
    PerfectScrollbar,
  },
  data() {
    return {
      sidebarClass: "",
      settings: {
        suppressScrollX: true,
      },
    };
  },  
  methods: {
    scrollHanle() {},
  },
};
</script>
